import React, {forwardRef} from 'react'
import {BackgroundStyle, BoxInContainerSX, ContainerAcasaSX, SectiuneTitluFontSX, VideoBackground} from "../App.styles";
import {Box, Button, Container} from "@mui/material";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import useMediaQuery from '@mui/material/useMediaQuery';
import video from '../imaginiSite/4941457-hd_1920_1080_25fps.mp4';

export const Acasa = forwardRef((props, ref) => {

    const { toRef } = props;

    const scrollToRef = (ref) => {
        ref.current?.scrollIntoView({ behavior: 'smooth' });
    }

    const isMobileWidth = useMediaQuery('(max-width:600px)');
    const isShort = useMediaQuery('(max-height:500px)');
    const isCompact = isMobileWidth || isShort;

    return (
        <div ref={ref} style={BackgroundStyle}>
            <video autoPlay loop muted style={{...VideoBackground, height: '100%'}}>
                <source src={video} type="video/mp4" />
            </video>
            <Container
                sx={{
                    ...ContainerAcasaSX,
                    pt: isCompact ? 7 : 8, // account for AppBar height (56/64px)
                    pb: 0,
                    minHeight: isCompact ? 'calc(100vh - 56px)' : 'calc(100vh - 64px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
                maxWidth={false}
            >
                <Box
                    sx={{...BoxInContainerSX, gap: 0, textAlign: 'center'}}
                >
                    <Typography component="h1" variant={isCompact ? 'h4' : 'h1'} color="text.primary"
                                style={{...SectiuneTitluFontSX, color: 'white', marginBottom: 0}}>
                        ALLPRO SERVICE
                    </Typography>
                    <Typography component="h2" variant={isCompact ? 'body2' : 'h5'} color="text.primary"
                                style={{...SectiuneTitluFontSX, color: 'white', marginBottom: 0}}>
                        <br/> Confecții metalice <br/> Relocări de echipamente şi utilaje
                    </Typography>
                    <Button onClick={() => scrollToRef(toRef)} style={{marginTop: 0}} disableRipple>
                        <KeyboardArrowDownIcon style={{color: 'white', fontSize: isCompact ? '56px' : '100px'}}/>
                    </Button>
                </Box>
            </Container>
        </div>
    )
})